module.exports = __webpack_public_path__ + "img/bg-cube.0c6c9b94.svg";